import React from 'react'
import Dashboard from '../../components/dashboard'

function Help() {
  return (
    <h1>Help</h1>
  )
}

export default Help